import { Outlet, createFileRoute } from "@tanstack/react-router";
import logo from "../assets/sidebar_logo.svg";

function AuthBase() {
  return (
    <div className="w-full h-dvh bg-[#1A1A2E] flex items-center pl-48 relative bg-auth bg-right bg-no-repeat">
      <div className="w-[40%] z-10">
        <img src={logo} alt="logo" height={35} width={35} className="mb-8" />
        <Outlet />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/auth")({
  component: () => <AuthBase />,
});
